<template>
  <div>
    <div class="d-flex mb-2">
      <SingleOptionDropdown class="flex-grow-1 mr-1" v-model="year" :options="years" :title="$t('year')" :index="1"></SingleOptionDropdown>
      <SingleOptionDropdown class="flex-grow-1 ml-1" v-model="month" :options="months" :title="$t('month')" :index="2"></SingleOptionDropdown>
    </div>
    <CTableWrapper ref="table" hover striped :caption="$t('pointMovements')" :items="items" :fields="fields" clickable-rows @update-requested="updateItemsRequested" :loading="loading">
    </CTableWrapper>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import CTableWrapper from "@/controls/PaginatedTable.vue";
import SearchBar from "@/controls/SearchBar.vue";
import i18n from '@/helpers/i18n';
import SingleOptionDropdown from '@/controls/SingleOptionDropdown.vue'

const START_YEAR = 2023;

export default {
  components: { CTableWrapper, SearchBar, SingleOptionDropdown },
  data () {
    return {
      searchText: '',
      itemsPerPage: localStorage.itemsPerPage ?? 10,
      fields: [
        { key: 'firstName', label: i18n.t('firstName'), _classes: 'font-weight-bold' },
        { key: 'lastName', label: i18n.t('lastName'), _classes: 'font-weight-bold' },
        { key: 'email', label: i18n.t('email'), _classes: 'font-weight-bold' },
        { key: 'points', label: i18n.t('points') },
      ],
      loading: false,
      year: new Date().getUTCFullYear().toString(),
      month: (new Date().getUTCMonth() + 1).toString()
    }
  },
  computed: {
    ...mapState('pointMovements', ['getRankingOutput']),
    pointMovementsInfo: function() {
      return this.getRankingOutput ? this.getRankingOutput : null;
    },
    items: function()
    {
      var result = this.pointMovementsInfo && this.pointMovementsInfo.data ? this.pointMovementsInfo.data : [];
      
      return result;
    },
    years: function()
    {
      var currentYear = new Date().getUTCFullYear(), years = [];
      var startYear = START_YEAR;  
      while ( startYear <= currentYear ) {
          years.push(startYear++);
      }   

      return years.map(x=> ({key: x.toString(), label: x}));
    },
    months: function()
    {
      var result = [{key: "1", label: this.$i18n.t("january")}, {key: "2", label: this.$i18n.t("february")}, {key: "3", label: this.$i18n.t("march")}, {key: "4", label: this.$i18n.t("april")}, {key: "5", label: this.$i18n.t("may")}, {key: "6", label: this.$i18n.t("june")}, {key: "7", label: this.$i18n.t("july")}, {key: "8", label: this.$i18n.t("august")}, {key: "9", label: this.$i18n.t("september")}, {key: "10", label: this.$i18n.t("october")}, {key: "11", label: this.$i18n.t("november")}, {key: "12", label: this.$i18n.t("december")}];

      if(this.year == new Date().getUTCFullYear())
      {
        result = result.slice(0, new Date().getUTCMonth() + 1);
      }

      return result;
    }
  },
  mounted: function()
  {
    this.updateItemsRequested();
  },
  methods: {
    ...mapActions('pointMovements', ['getRanking']),
    ...mapActions('pointMovements', ['deletePointMovementById']),
    updateItemsRequested()
    {
      let self = this;
      this.getRanking({year: self.year, month: self.month}); 
    }
  },
  watch:
  {
    year: function()
    {
      this.month = null;
    },
    month: function(val)
    {
      if(val && this.year)
      {
        this.updateItemsRequested();
      }
    },
    getRankingOutput: function(val)
    {
      if(val != null)
      {
        this.loading = false;
      }
    }
  }
}
</script>

 
<style>
th
{
  border-top: none !important;
}

tr
{
  cursor: pointer;
}

.status-button
{
  border: none;
  padding: 0;
  text-decoration: underline;
  color: #321fdb;
}
</style> 